import theme from "css/theme/light"

export const sharedStyle = {
  background: theme.palette.background.default.light,
  minHeight: "34px",
  color: theme.palette.grey["500"],
  "& a": {
    padding: "12px 16px;",
    textDecoration: "none",
    fontSize: "14px",
    color: "rgba(0, 0, 0, 0.87)",
    minHeight: "34px",
    fontWeight: 400,
    minWidth: 115,
    "&.Mui-selected": { fontWeight: 700, color: theme.palette.grey["500"] }
  },
  "& .MuiTab": {
    color: "red"
  },

  "& .MuiTab-root": {
    minHeight: "24px"
  }
}
